/**
 * @generated SignedSource<<5194abc0240e5ab872839d591fe111a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku$data = {
  readonly serviceId?: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbShipping_sku"
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "ef4e3715e4bdd3400549a2ec69992813";

export default node;
